import { FC, Fragment, useState } from 'react';
import Dropzone from 'react-dropzone';
import SvgIcon from './SvgIcon';


const CommonFileUpload: FC<{
  multiple?: boolean;
  onlyVideo?: boolean;
  accept?: any;
  onFilesChange?: (files: File[]) => void;
}> = ({ multiple, onlyVideo, accept, onFilesChange }) => {
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

  const onDrop = (acceptedFiles: File[]) => {
    const files = onlyVideo
      ? acceptedFiles.filter((f) => f.type.startsWith('video/'))
      : acceptedFiles;
    setUploadedFiles((prevFiles) => {
      const merged = [...prevFiles, ...files];
      onFilesChange?.(merged);
      return merged;
    });
  };

  const removeFile = (indexToRemove: number) =>
    setUploadedFiles((prevFiles) => {
      const updated = prevFiles.filter((_, index) => index !== indexToRemove);
      onFilesChange?.(updated);
      return updated;
    });
  return (
    <Fragment>
      {uploadedFiles.length === 0 ? (
        <Dropzone onDrop={onDrop} accept={accept}>
          {({ getRootProps, getInputProps }) => (
            <div {...getRootProps()} className="dropzone-container">
              <input {...getInputProps()} />
              <div className="dz-message needsclick">
                <SvgIcon iconId="file-upload1" />
                <h5>Drag Files or Click to Browse</h5>
              </div>
            </div>
          )}
        </Dropzone>
      ) : (
        <Fragment>
          {multiple && (
            <Dropzone onDrop={onDrop} accept={accept}>
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()} className="add-more-files-zone">
                  <input {...getInputProps()} />
                  <p>Click or drag more files to add</p>
                </div>
              )}
            </Dropzone>
          )}

          <div className="uploaded-files">
            {uploadedFiles.map((file, index) => (
              <div key={index} className="file-card">
                {file.type.startsWith('image/') ? (
                  <img src={URL.createObjectURL(file)} alt={file.name} className="file-thumbnail" />
                ) : (
                  <div className="file-placeholder">
                    {file.name.split('.').pop()?.toUpperCase()} File
                  </div>
                )}
                <p className="file-name">{file.name}</p>
                <p className="file-size">{(file.size / 1024).toFixed(2)} KB</p>

                <button
                  onClick={() => removeFile(index)}
                  className="remove-button"
                  title="Remove file"
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default CommonFileUpload;
